import { Progress } from 'antd';
import React, { useState } from 'react'
import { classcardProps } from './classcard-interface';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { openNotificationWithIcon } from '../../../../../utils/helper';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom'
import { Dropdown } from 'antd'
import Deleteclass from '../teacherclass/deleteclass/deleteclass';
import Editclass from '../editclass/editclass';

const Classcard = ({ details, runReloadClasses }: classcardProps) => {
	const navigate = useNavigate()

	const [showDeleteClass, setShowDeleteClass] = useState(false)
	const [showEditClass, setShowEditClass] = useState(false)

	const closeShowDelete = (reload?: boolean) => {
		setShowDeleteClass(false)
		if (reload) {
			if (runReloadClasses !== undefined) {
				runReloadClasses()
			}
		}
	}

	const closeShowEditClass = (reload?: boolean) => {
		setShowEditClass(false)
		if (reload) {
			if (runReloadClasses !== undefined) {
				runReloadClasses()
			}
		}
	}

	const getOtherTeachers = () => {
		if (details?.subTeachers?.length > 0) {
			if (details?.subTeachers?.length === 1) {
				return details?.subTeachers[0]?.firstName !== undefined ?
					`& ${details?.subTeachers[0]?.firstName}` : `& 1 other`
			} else {
				return `& ${details?.subTeachers?.length} others`
			}
		}
		return null
	}

	const items: MenuProps['items'] = [
		{
			key: `${details?._id}-open`,
			label: (
				<a rel="noopener noreferrer" href={`/teacher/dashboard/curriculum/${details._id}`}
					onClick={(e) => {
						e.preventDefault()
						navigate(`/teacher/dashboard/class/${details._id}`)
					}}
				>
					Open
				</a>
			),
		},
		{
			key: `class-edit-open`,
			label: (
				<a rel="noopener noreferrer" href={`/teacher/dashboard/curriculum/${details._id}`}
					onClick={(e) => {
						e.preventDefault()
						setShowEditClass(true)
					}}
				>
					Edit
				</a>
			),
		},
		{
			key: `class-delete-class`,
			label: (
				<a rel="noopener noreferrer" href={`/teacher/dashboard/curriculum/${details._id}`}
					onClick={(e) => {
						e.preventDefault()
						setShowDeleteClass(true)
					}}
					style={{
						color: 'red'
					}}
				>
					Delete
				</a>
			),
		},
	];

	return (
		<div className='relative'>
			<div className='absolute bottom-[1rem] right-0'>
				<Dropdown
					menu={{ items }}
					placement="bottomRight"
				>
					<img src="/img/vectors/more.svg" alt="more" className='w-8 h-5 cursor-pointer' />
				</Dropdown>
			</div>

			<div className={`mb-[1.8rem] flex pb-[1.1rem] border-b border-appcolordeepwhite cursor-pointer`}
				onClick={() => {
					navigate(`/teacher/dashboard/class/${details._id}`)
				}}
			>
				<div className='flex flex-col items-center justify-between'>
					<div className='flex flex-col items-center'>
						<div className='relative flex justify-center'>
							<div className='absolute top-[-0.3rem] mx-auto'>
								<Progress
									type="circle"
									percent={details?.percentage ?? 0}
									trailColor="#d8edda"
									strokeColor="#3da344"
									showInfo={false}
									size={63}
								/>
							</div>

							<div className='flex items-center justify-center bg-appcolorwhite p-[0.1rem] rounded-full relative'
							>
								<img src="/img/vectors/python.svg" alt="python" className='w-[3rem] h-[3rem]' />
							</div>
						</div>

						{
							details?.percentage !== undefined ?
								<p className='text-appcolorgreenfour font-[900] text-xl mt-3 '>
									0%
								</p> :
								null
						}

					</div>


					<div className='flex mt-5'>
						<img src="/img/vectors/classcardmessage.svg" alt="message" />
						<p className='pl-1 text-sm font-semibold text-appcolorfaintpurpletwo'>
							0
						</p>
					</div>
				</div>
				<div className='flex-grow pl-5'>
					<p className='text-xl font-[900] text-appcolorpurplefaintone'>{details.name}</p>

					<div className='flex justify-between mt-3 item-center'>
						<div className='flex items-center'>
							<img src="/img/vectors/classcarduser.svg" alt="users" className='w-5 h-5' />

							<div className='flex items-center'>
								<p className='pr-1 text-sm font-extrabold text-appcolorfaintpurpletwo'>{details.students.length}</p>
								<p className='text-xs font-semibold text-appcolorfaintpurplethree'>Student</p>
							</div>
						</div>
						{/* 
						<div className='flex items-center'>
							<img src="/img/vectors/classcardtime.svg" alt="users" className='w-5 h-5' />

							<div className='flex items-center'>
								<p className='pr-1 text-sm font-extrabold text-appcolorfaintpurpletwo'>20</p>
								<p className='text-xs font-semibold text-appcolorfaintpurplethree'>min/class</p>
							</div>
						</div> */}
					</div>

					<div className='mt-3 bg-appcolorfaintpurpletfour rounded-[0.3rem] w-fit flex px-[0.3rem] py-[0.1rem]'>
						<img src="/img/vectors/copy.svg" alt="copy" className='w-5 h-5 pr-1' />

						<CopyToClipboard
							text={details.code}
							onCopy={() => {
								openNotificationWithIcon('info', "Copy Code", 'Class code copied to clipboard')
							}}>
							<p className='cursor-pointer text-appcolorfaintpurpletwo'>Copy Class Code</p>
						</CopyToClipboard>

					</div>

					<div className='flex items-center justify-between mt-3'>
						<div className='flex items-center'>
							<img src="/img/vectors/school.svg" alt="teachers" className='w-5 h-5' />
							<p className='pl-1 text-base font-extrabold text-appcolorfaintpurpletwo'>
								Me {getOtherTeachers()}
							</p>
						</div>
					</div>
				</div>
				<div>
				</div>
			</div>

			{
				showEditClass ?
					<Editclass
						open={showEditClass}
						closeModal={closeShowEditClass}
						language={details?.languageId?.name}
						classId={details?._id || ''}
						classDetails={{
							name: details?.name,
							description: details?.description
						}}
					/> : null
			}

			{
				showDeleteClass ?
					<Deleteclass
						open={showDeleteClass}
						closeModal={closeShowDelete}
						classId={details?._id || ''}
					/>
					: null
			}
		</div>
	)
}

export default Classcard